import {customType} from 'drizzle-orm/pg-core';
import {rewardSubmission, type RewardSubmission} from './rewardSubmission';

export const pgRewardSubmissionColumn = customType<{
  data: RewardSubmission;
  driverData: unknown;
}>({
  dataType() {
    return 'jsonb';
  },
  toDriver(value: RewardSubmission) {
    return JSON.stringify(value);
  },
  fromDriver(value) {
    const parsed = rewardSubmission.safeParse(value);

    if (parsed.error) {
      console.error('invalid data in pgMessageAttachment', value, parsed.error);
      throw parsed.error;
    }

    return parsed.data;
  },
});
